<template>

  <v-flex
    md12
  >
    <div>
      <!--      <material-card-->
      <!--        color="general"-->
      <!--        title="Item Bundling Data"-->
      <!--        text="List of Item Bundling Material"-->
      <!--      >-->
      <v-text-field
        v-model="search"
        prepend-icon="search"
        label="Search"
        placeholder="search by brand/material/category/desc"
        clearable
        single-line
        hide-details/>
      <v-dialog
        v-model="dialog"
        persistent
        max-width="1024px">
        <template v-slot:activator="{ on }">
          <v-btn
            color="general"
            class="mb-2"
            dark
            v-on="on"
          >New Bundling
          </v-btn>
        </template>
        <v-form
          id="form-vue"
          ref="form"
          v-model="valid"
          :lazy-validation="lazy"
        >
          <v-card>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm6
                    md4>
                    <v-text-field
                      v-model="editedItem.brand"
                      :rules="[rules.required,rules.max50chars]"
                      label="Brand *"
                      value="OIS"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md4>
                    <v-text-field
                      v-model="editedItem.category"
                      :rules="[rules.max50chars]"
                      label="Category"/>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md4>
                    <v-text-field
                      v-model="editedItem.materialNo"
                      :rules="[rules.required,rules.max50chars]"
                      label="Material No *"/>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    md8>
                    <v-textarea
                      v-model="editedItem.materialDesc"
                      :rules="[rules.required]"
                      label="Description"
                      clearable
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    md12>
                    <v-card-actions>
                      <v-text-field
                        v-model="searchSub"
                        prepend-icon="search"
                        label="Search"
                        placeholder="search by brand/material/category/desc"
                        clearable
                        single-line
                        hide-details/>
                    <v-chip
                        class="ma-2"
                        color="warning"
                        outlined
                    >
                      <v-icon left>mdi-information-outline</v-icon>
                      All Prices Automatic Convert to IDR
                    </v-chip>
                    </v-card-actions>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    md12>
                    <v-data-table
                      v-model="selectedSub"
                      :headers="subHeaders"
                      :items="SubDataList"
                      :loading="loadingSub"
                      :pagination.sync="paginationSub"
                      :rows-per-page-items="rowsAmount"
                      :total-items="totalRowsSub"
                      loading-text="Loading... Please wait"
                      expand="expand"
                      dense
                      select-all
                      item-key="id"
                      class="elevation-1"
                    >
                      <template v-slot:items="props">
                        <tr
                          class="expandable"
                          @click.stop="props.expanded = !props.expanded">
                          <td>
                            <v-checkbox
                              v-model="props.selected"
                              hide-details
                              primary
                              @click.stop="props.selected = !props.selected"
                            />
                          </td>
                          <td>{{ props.item.brand }}</td>
                          <td>{{ props.item.category }}</td>
                          <td>{{ props.item.materialNo }}</td>
                          <td>{{ props.item.currency }}</td>
                          <td>
                            <v-edit-dialog
                                :return-value.sync="props.item.qty"
                                lazy
                                large
                                @click.native.stop
                                @save="saveInline"
                                @cancel="cancelInline"
                                @close="closeInline"
                            >
                              <div>{{ props.item.qty }}
                                <v-icon small>mdi-pencil</v-icon>
                              </div>
                              <template v-slot:input>
                                <v-text-field
                                    v-model="props.item.qty"
                                    :rules="[rules.required,rules.number]"
                                    single-line
                                    counter
                                    autofocus
                                />
                              </template>
                            </v-edit-dialog>
                          </td>
                          <td class="price-format">{{ toPriceFormat(props.item.price.sellingPrice) }}</td>
                          <td class="price-format">{{ toPriceFormat(props.item.price.bottomPrice) }}</td>
                        </tr>
                      </template>
                      <template v-slot:expand="props">
                        <v-card>
                          <v-card-text align="left"><span class="expand-item">Material Desc:</span> {{
                          props.item.materialDesc }}
                          </v-card-text>
                        </v-card>
                      </template>
                    </v-data-table>
                  </v-flex>

                  <!--                  <v-flex-->
                  <!--                    xs12-->
                  <!--                    sm6-->
                  <!--                    md4>-->
                  <!--                    <v-text-field-->
                  <!--                      v-model="editedItem.price.suppPrice"-->
                  <!--                      :rules="[rules.number]"-->
                  <!--                      :hint = "suppPriceHint"-->
                  <!--                      :value="totalSuppPrice"-->
                  <!--                      label="Supplier Price (IDR)"/>-->
                  <!--                  </v-flex>-->
                  <!--                    <v-flex-->
                  <!--                      xs12-->
                  <!--                      sm6-->
                  <!--                      md4>-->
                  <!--                      <v-select-->
                  <!--                        :items="currencyList"-->
                  <!--                        v-model="editedItem.curr"-->
                  <!--                        :rules="[rules.required]"-->
                  <!--                        item-text="code"-->
                  <!--                        item-value="code"-->
                  <!--                        label="Source Currency *"-->
                  <!--                        placeholder="Select..."-->
                  <!--                      />-->
                  <!--                    </v-flex>-->
                  <v-flex
                    xs12
                    sm6
                    md4>
                    <v-text-field
                      v-model="editedItem.price.sellingPrice"
                      :rules="[rules.number]"
                      :hint="suppPriceHint"
                      :value="totalSellPrice"
                      label="Selling Price (IDR)"/>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md4>
                    <v-text-field
                      v-model="editedItem.price.bottomPrice"
                      :rules="[rules.number]"
                      :hint="suppPriceHint"
                      :value="totalBotPrice"
                      label="Bottom Price (IDR)"/>
                  </v-flex>

                </v-layout>
              </v-container>
              <small>*indicates required field</small>
            </v-card-text>

            <v-card-actions>
              <v-spacer/>
              <v-btn
                color="red darken-1"
                flat
                @click.stop="close">Cancel
              </v-btn>
              <v-btn
                :disabled="!valid"
                color="green darken-1"
                flat
                @click.stop="save">Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog
        v-model="dialogDelete"
        max-width="400px">
        <v-card>
          <v-card-title class="headline">System Message Confirmation</v-card-title>
          <v-card-text>
            Are you sure want to remove this data? <br>
            "{{ deleteItemRecord.brand }} - {{ deleteItemRecord.materialNo }}"
          </v-card-text>
          <v-card-actions>
            <v-spacer/>

            <v-btn
              color="red darken-1"
              text
              flat
              @click="dialogDelete = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="green darken-1"
              text
              flat
              @click="deleteItem(deleteItemRecord)"
            >
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="DataList"
        :rows-per-page-items="rowsAmount"
        :pagination.sync="pagination"
        :total-items="totalRows"
        dense
        loading-text="Loading... Please wait"
        class="elevation-1"
      >

        <template v-slot:items="props">
          <tr
            class="expandable"
            @click="props.expanded = !props.expanded">
            <td>{{ props.item.brand }}</td>
            <td>{{ props.item.category }}</td>
            <td>{{ props.item.materialNo }}</td>
            <td>{{ props.item.currency }}</td>
            <!--            <td>{{ props.item.price.suppPrice }}</td>-->
            <td>{{ props.item.price.sellingPrice }}</td>
            <td>{{ props.item.price.bottomPrice }}</td>
            <td>{{ props.item.lastUpdateBy }}</td>
            <td>{{ toStringDate(props.item.lastUpdateDate) }}</td>
            <td class="justify-center ">
              <v-icon
                medium
                class="mr-2"
                @click.stop="editItem(props.item)">edit
              </v-icon>
              <v-icon
                medium
                @click.stop="dialogDeleteShow(props.item)">delete
              </v-icon>
            </td>
          </tr>
        </template>
        <template v-slot:expand="props">
          <v-flex mx-3>
            <v-card>
              <v-card-text align="left"><span class="expand-item">Material Desc:</span> {{ props.item.materialDesc }}
              </v-card-text>
            </v-card>
          </v-flex>
          <v-spacer/>
          <v-flex mx-3>

            <v-data-table
              id="bundlinglist"
              :items="props.item.items"
              :headers="subHeadersExpand"
              class="elevation-1"
              dense
              hide-actions
            >
              <template v-slot:items="props">
                <tr>
                  <td>{{ props.item.brand }}</td>
                  <td class="">{{ props.item.category }}</td>
                  <td class="">{{ props.item.materialNo }}</td>
                  <td class="">{{ props.item.materialDesc }}</td>
                  <td class="">{{ props.item.currency }}</td>
                  <!--                  <td class="">{{ props.item.price.suppPrice }}</td>-->
                  <td class="price-format">{{ toPriceFormat(props.item.price.sellingPrice) }}</td>
                  <td class="price-format">{{ toPriceFormat(props.item.price.bottomPrice) }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </template>
      </v-data-table>
      <v-snackbar
        v-model="snack"
        :timeout="5000"
        :color="snackColor">
        {{ snackText }}
        <v-btn
          flat
          @click="snack = false">Close
        </v-btn>
      </v-snackbar>
      <!--      </material-card>-->
    </div>
  </v-flex>

</template>

<script>
  import displayFormatterMixins from '../../../mixins/displayFormatterMixins'
  import _ from 'lodash'

  export default {
    name: 'ItemBundling',
    mixins: [displayFormatterMixins],
    props: {
      // eslint-disable-next-line vue/require-default-prop
      currencyList: Array
    },
    data: () => ({
      snack: false,
      valid: false,
      lazy: false,
      snackColor: '',
      snackText: '',
      rules: {
        required: value => !!value || 'Required.',
        max50chars: value => !value || value.length <= 50 || 'Max 50 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return !value || pattern.test(value) || 'Invalid e-mail.'
        },
        number: value => !isNaN(value) || 'Must be numeric'
      },
      expand: true,
      pagination: {},
      paginationSub: {},
      DataList: [],
      SubDataList: [],
      selectedSub: [],
      totalRows: 0,
      totalRowsSub: 0,
      rowsAmount: [5, 10],
      dialog: false,
      dialogDelete: false,
      deleteItemRecord: {},
      loading: true,
      loadingSub: true,
      search: '',
      searchBy: {
        brand: '',
        category: '',
        materialNo: '',
      },
      searchSub: '',
      headers: [
        { text: 'Brand', value: 'brand' },
        { text: 'Category', value: 'category' },
        { text: 'Material', value: 'materialNo' },
        { text: 'Curr', value: 'curr' },
        // { text: 'Supp Price', value: 'price.suppPrice' },
        { text: 'Selling Price', value: 'price.sellingPrice' },
        { text: 'Bottom Price', value: 'price.bottomPrice' },
        { text: 'Update By', value: 'lastUpdateBy' },
        { text: 'Update Date Time', value: 'lastUpdateDate' },
        { text: '--Actions--', value: 'actions', sortable: false }
      ],
      subHeaders: [
        { text: 'Brand', value: 'brand' },
        { text: 'Category', value: 'category' },
        { text: 'Material', value: 'materialNo' },
        { text: 'Curr', value: 'curr' },
        { text: 'Qty', value: 'qty' },
        { text: 'Selling Price', value: 'price.sellingPrice' },
        { text: 'Bottom Price', value: 'price.bottomPrice' }
      ],
      subHeadersExpand: [
        { text: 'Brand', value: 'brand', sortable: false },
        { text: 'Category', value: 'category', sortable: false },
        { text: 'Material', value: 'materialNo', sortable: false },
        { text: 'Material Desc', value: 'materialDesc', sortable: false },
        { text: 'Curr', value: 'curr', sortable: false },
        // { text: 'Supp Price', value: 'price.suppPrice', sortable: false },
        { text: 'Selling Price', value: 'price.sellingPrice', sortable: false },
        { text: 'Bottom Price', value: 'price.bottomPrice', sortable: false }
      ],
      editedIndex: -1,
      editedItem: {
        id: null,
        brand: '',
        materialNo: '',
        materialDesc: '',
        price: {
          suppPrice: '',
          sellingPrice: '',
          bottomPrice: ''
        },
        items: [],
        currency: 'IDR',
        category: '',
        isBundling: true
      },
      suppPriceHint: '(IDR)',
      defaultItem: {
        id: null,
        brand: '',
        materialNo: '',
        materialDesc: '',
        price: {
          suppPrice: '',
          sellingPrice: '',
          bottomPrice: ''
        },
        items: [],
        currency: 'IDR',
        category: '',
        isBundling: true
      },
      rates: []
    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
      // totalSuppPrice () {
      //   let sum = _.sumBy(this.selectedSub, function (object) {
      //     console.log(object.price.suppPrice)
      //     return object.price.suppPrice
      //   })
      //   this.editedItem.price.suppPrice = sum
      //   return sum
      // },
      totalSellPrice () {
        console.debug('---- Selling Price -----')
        console.debug(this.selectedSub)
        console.debug(this.rates)
        let ratesArr = this.rates
        let sum = _.sumBy(this.selectedSub, function (object) {
          console.debug(object.currency)
          let qty = object.qty || 1
          let value = _.find(ratesArr, function (rate) {
            return rate.sourceCurr === object.currency && rate.targetCurr === 'IDR'
          })
          console.debug(value ? value.convValue : 1)
          return object.price.sellingPrice * (value ? value.convValue : 1) * qty
        })
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.editedItem.price.sellingPrice = sum
        console.debug('---- END of -----')
        return sum
      },
      totalBotPrice () {
        let ratesArr = this.rates
        let sum = _.sumBy(this.selectedSub, function (object) {
          let qty = object.qty || 1
          let value = _.find(ratesArr, function (rate) {
            return rate.sourceCurr === object.currency && rate.targetCurr === 'IDR'
          })
          console.debug(value ? value.convValue : 1)
          return object.price.bottomPrice * (value ? value.convValue : 1) * qty
        })
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.editedItem.price.bottomPrice = sum
        return sum
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      pagination: {
        async handler () {
          this.getItemsBundling()
        },
        deep: true
      },
      search () {
        this.debouncedGetItemsBundling()
      },
      paginationSub: {
        async handler () {
          this.getItemsMaster()
        },
        deep: true
      },
      searchSub () {
        this.debouncedGetItemsMaster()
      }
    },
    // called when page is created before dom
    created () {
      this.debouncedGetItemsBundling = _.debounce(this.getItemsBundling, 500)
      this.debouncedGetItemsMaster = _.debounce(this.getItemsMaster, 500)
      this.getRate()
    },
    mounted () {
      // this.getItemsBundling()
    },
    methods: {
      toggleAll () {
        console.log(this.selectedSub.length)
        console.log(this.pagination)
        if (this.selectedSub.length) this.selectedSub = []
        else this.selectedSub = this.SubDataList.slice()
        console.log('toogle All')
        console.log(this.selectedSub)
      },
      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      async getRate (targetCurr) {
        let response = await this.$http.get(`/api/exchangerate/select?tgt=IDR`)
        this.rates = response.data
        console.log(response.data)

        // console.log(this.rates)
        //   return _.find(this.rates, function (rate) {
        //     return rate.sourceCurr === 'IDR' && rate.targetCurr === targetCurr
        //   }).convValue || 1
      },
      async getItemsBundling () {
        try {
          this.loading = true
          const { sortBy, descending, page, rowsPerPage } = this.pagination
          let q = this.search == null ? '' : this.search

          let pageNoXHR = page - 1
          let response = await this.$http.get(`/api/itembundling?isb=true&ps=${rowsPerPage}&pn=${pageNoXHR}&so=${sortBy || 'lastUpdateDate'}&dc=${descending || false}&q=${q}`)

          this.loading = false
          this.DataList = response.data.content
          this.totalRows = response.data.totalElements
        } catch (error) {
          console.log(error)
        }
      },

      async getItemsMaster () {
        try {
          this.loadingSub = true
          const { sortBy, descending, page, rowsPerPage } = this.paginationSub
          let q = this.searchSub == null ? '' : this.searchSub
          let qbra = this.searchBy.brand == null ? '' : this.searchBy.brand
          let qcat = this.searchBy.category == null ? '' : this.searchBy.category
          let qmat = this.searchBy.materialNo == null ? '' : this.searchBy.materialNo
          let pageNoXHR = page - 1
          let response = await this.$http.get(`/api/item?ps=${rowsPerPage}&pn=${pageNoXHR}&so=${sortBy || ''}
          &dc=${descending || false}&q=${q}&qbra=${qbra}&qcat=${qcat}&qmat=${qmat}`)

          this.loadingSub = false
          this.SubDataList = response.data.content
          this.totalRowsSub = response.data.totalElements
        } catch (error) {
          console.log(error)
        }
      },

      // object.assign fills in the empty object with the properties of item
      async editItem (item, dbox = true) {
        this.editedIndex = this.DataList.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.selectedSub = this.editedItem.items
        console.log(this.selectedSub)
        console.log('edit item')
        console.log(this.editedItem.items)
        this.dialog = dbox
      },

      callTableAction (item, endpoint, method) {
        let tableItem = this.editedItem
        this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
          .then((response) => this.saveInline())
          .catch(error => {
            console.log(error)
            this.cancelInline()
          })
      },

      dialogDeleteShow (data) {
        this.dialogDelete = true
        this.deleteItemRecord = data
      },

      deleteItem (rec) {
        let endpoint = `api/itembundling/${rec.id}`
        let method = 'delete'
        let s = {}
        this.DataList.splice(this.DataList.indexOf(rec), 1)
        this.$store.dispatch('updateTableItem', { endpoint, s, method })
          .then((response) => this.deleteInline())
          .catch(error => {
            console.log(error)
            this.cancelInline()
          })
        this.dialogDelete = false
      },

      close () {
        console.log(this.selectedSub)
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          this.selectedSub = []
        }, 300)
      },

      save () {
        if (!this.$refs.form.validate()) {
          console.log('validation fail direct')
        }
        if (this.$refs.form.validate()) {
          console.log('validation success')
        }
        if (this.editedIndex > -1) {
          this.editedItem.currency = 'IDR'
          Object.assign(this.DataList[this.editedIndex], this.editedItem)
          let tableItem = this.editedItem
          let endpoint = `api/itembundling/${this.editedItem.id}`
          let method = 'patch'
          this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            .then((response) => this.saveInline())
            .catch(error => {
              console.log(error)
              this.cancelInline()
            })
        } else {
          this.editedItem.items = this.selectedSub
          console.log(this.selectedSub)
          this.editedItem.currency = 'IDR'
          let tableItem = this.editedItem
          this.DataList.push(this.editedItem)
          let endpoint = `api/itembundling`
          let method = 'post'
          this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            .then((response) => {
              if (response.data.message === 'FAILED') {
                this.cancelInline(response.data.details)
              } else {
                this.saveInline()
                this.getItemsBundling()
              }
            })
            .catch(error => {
              console.log(error)
              this.cancelInline()
            })
        }
        this.close()
      },
      syncItemQty (qty, property) {
        console.log('msk')
        console.log(qty)
        console.log(property)
        // if (isNaN(qty)) {
        //   property = 0
        // } else {
        //   property = qty
        // }
      },
      // toasts/snackbar messages for actions
      saveInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data saved/updated'
      },
      cancelInline (txt) {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = txt || 'Canceled'
      },
      deleteInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data removed'
      },
      reset () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data reset to default'
      },
      openInline () {
        this.snack = true
        this.snackColor = 'info'
        this.snackText = 'Dialog opened'
      },
      closeInline () {
        console.debug('Dialog closed')
      }
    }
  }
</script>

<style>
  #bundlinglist thead tr {
    background-color: antiquewhite;
  }

  #bundlinglist table.v-table thead tr th {
    font-size: 1.025em;
  }
</style>
